import { SharingDetails } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/views/SharingDetails';
import { ShiftBiddingDetails } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/views/ShiftBiddingDetails';
import { TieringDetails } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/views/TieringDetails';
import { ModalRoutingService } from 'services';

export const ShiftDistributionComponentMap = {
  SharingDetails,
  TieringDetails,
  ShiftBiddingDetails,
};

export const tieringDetailsModalRoutingService = new ModalRoutingService(
  'tieringDetails',
  'TieringDetails',
  ShiftDistributionComponentMap,
  {},
  ['TieringDetails', 'SharingDetails', 'ShiftBiddingDetails'],
);
